// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export type {
  Agent,
  AgentVersion,
  AgentDefinition,
  AgentDefinitionUnion,
  AgentKind,
  RaiConfig,
  HostedAgentDefinition,
  Tool,
  ToolUnion,
  ToolType,
  BingGroundingTool,
  BingGroundingSearchToolParameters,
  BingGroundingSearchConfiguration,
  MicrosoftFabricPreviewTool,
  FabricDataAgentToolParameters,
  ToolProjectConnection,
  SharepointPreviewTool,
  SharepointGroundingToolParameters,
  AzureAISearchTool,
  AzureAISearchToolResource,
  AISearchIndexResource,
  AzureAISearchQueryType,
  OpenApiTool,
  OpenApiFunctionDefinition,
  OpenApiAuthDetails,
  OpenApiAuthDetailsUnion,
  OpenApiAuthType,
  OpenApiAnonymousAuthDetails,
  OpenApiProjectConnectionAuthDetails,
  OpenApiProjectConnectionSecurityScheme,
  OpenApiManagedAuthDetails,
  OpenApiManagedSecurityScheme,
  BingCustomSearchPreviewTool,
  BingCustomSearchToolParameters,
  BingCustomSearchConfiguration,
  BrowserAutomationPreviewTool,
  BrowserAutomationToolParameters,
  BrowserAutomationToolConnectionParameters,
  AzureFunctionTool,
  AzureFunctionDefinition,
  AzureFunctionBinding,
  AzureFunctionStorageQueue,
  CaptureStructuredOutputsTool,
  StructuredOutputDefinition,
  A2APreviewTool,
  WorkIQPreviewTool,
  WorkIQPreviewToolParameters,
  MemorySearchPreviewTool,
  MemorySearchOptions,
  CodeInterpreterTool,
  AutoCodeInterpreterToolParam,
  ContainerMemoryLimit,
  ContainerNetworkPolicyParam,
  ContainerNetworkPolicyParamUnion,
  ContainerNetworkPolicyParamType,
  ContainerNetworkPolicyDisabledParam,
  ContainerNetworkPolicyAllowlistParam,
  ContainerNetworkPolicyDomainSecretParam,
  FunctionTool,
  FileSearchTool,
  RankingOptions,
  RankerVersionType,
  HybridSearchOptions,
  Filters,
  ComparisonFilter,
  ComparisonFilterValueItems,
  CompoundFilter,
  ComputerUsePreviewTool,
  ComputerEnvironment,
  WebSearchTool,
  WebSearchToolFilters,
  WebSearchApproximateLocation,
  WebSearchConfiguration,
  MCPTool,
  MCPToolFilter,
  MCPToolRequireApproval,
  ImageGenTool,
  InputFidelity,
  ImageGenToolInputImageMask,
  ImageGenAction,
  LocalShellToolParam,
  FunctionShellToolParam,
  FunctionShellToolParamEnvironment,
  FunctionShellToolParamEnvironmentUnion,
  FunctionShellToolParamEnvironmentType,
  FunctionShellToolParamEnvironmentLocalEnvironmentParam,
  LocalSkillParam,
  FunctionShellToolParamEnvironmentContainerReferenceParam,
  ContainerAutoParam,
  ContainerSkill,
  ContainerSkillUnion,
  ContainerSkillType,
  SkillReferenceParam,
  InlineSkillParam,
  InlineSkillSourceParam,
  CustomToolParam,
  CustomToolParamFormat,
  CustomToolParamFormatUnion,
  CustomToolParamFormatType,
  CustomTextFormatParam,
  CustomGrammarFormatParam,
  GrammarSyntax,
  WebSearchPreviewTool,
  ApproximateLocation,
  SearchContextSize,
  SearchContentType,
  ApplyPatchToolParam,
  ComputerTool,
  NamespaceToolParam,
  FunctionToolParam,
  EmptyModelParam,
  ToolSearchToolParam,
  ToolSearchExecutionType,
  ProtocolVersionRecord,
  AgentProtocol,
  ContainerConfiguration,
  CodeConfiguration,
  PromptAgentDefinition,
  Reasoning,
  ReasoningEffort,
  ToolChoiceParam,
  ToolChoiceParamUnion,
  ToolChoiceParamType,
  ToolChoiceAllowed,
  ToolChoiceFunction,
  ToolChoiceMCP,
  ToolChoiceCustom,
  SpecificApplyPatchParam,
  SpecificFunctionShellParam,
  ToolChoiceFileSearch,
  ToolChoiceWebSearchPreview,
  ToolChoiceComputerUsePreview,
  ToolChoiceWebSearchPreview20250311,
  ToolChoiceImageGeneration,
  ToolChoiceCodeInterpreter,
  ToolChoiceComputer,
  ToolChoiceComputerUse,
  PromptAgentDefinitionTextOptions,
  TextResponseFormat,
  TextResponseFormatUnion,
  TextResponseFormatConfigurationType,
  TextResponseFormatJsonSchema,
  TextResponseFormatText,
  TextResponseFormatJsonObject,
  StructuredInputDefinition,
  WorkflowAgentDefinition,
  AgentIdentity,
  AgentBlueprintReference,
  AgentBlueprintReferenceUnion,
  AgentBlueprintReferenceType,
  ManagedAgentIdentityBlueprintReference,
  AgentEndpoint,
  VersionSelector,
  VersionSelectionRule,
  VersionSelectionRuleUnion,
  VersionSelectorType,
  FixedRatioVersionSelectionRule,
  AgentEndpointProtocol,
  AgentEndpointAuthorizationScheme,
  AgentEndpointAuthorizationSchemeUnion,
  AgentEndpointAuthorizationSchemeType,
  EntraAuthorizationScheme,
  IsolationKeySource,
  IsolationKeySourceUnion,
  IsolationKeySourceKind,
  EntraIsolationKeySource,
  HeaderIsolationKeySource,
  BotServiceAuthorizationScheme,
  BotServiceRbacAuthorizationScheme,
  AgentCard,
  AgentCardSkill,
  ApiErrorResponse,
  ErrorModel,
  DeleteAgentResponse,
  DeleteAgentVersionResponse,
  EvaluationRule,
  EvaluationRuleAction,
  EvaluationRuleActionUnion,
  EvaluationRuleActionType,
  ContinuousEvaluationRuleAction,
  HumanEvaluationPreviewRuleAction,
  EvaluationRuleFilter,
  EvaluationRuleEventType,
  Connection,
  ConnectionType,
  BaseCredentials,
  BaseCredentialsUnion,
  CredentialType,
  ApiKeyCredentials,
  EntraIDCredentials,
  CustomCredential,
  SASTokenCredentials,
  NoAuthenticationCredentials,
  AgenticIdentityPreviewCredentials,
  DatasetVersion,
  DatasetVersionUnion,
  DatasetType,
  FileDatasetVersion,
  FolderDatasetVersion,
  PendingUploadRequest,
  PendingUploadResponse,
  BlobReference,
  SasCredential,
  DatasetCredential,
  Deployment,
  DeploymentUnion,
  DeploymentType,
  ModelDeployment,
  ModelDeploymentSku,
  Index,
  IndexUnion,
  IndexType,
  AzureAISearchIndex,
  FieldMapping,
  ManagedAzureAISearchIndex,
  CosmosDBIndex,
  EmbeddingConfiguration,
  VersionIndicator,
  VersionIndicatorUnion,
  VersionIndicatorType,
  VersionRefIndicator,
  AgentSessionResource,
  AgentSessionStatus,
  SessionFileWriteResponse,
  SessionDirectoryListResponse,
  SessionDirectoryEntry,
  EvaluationTaxonomy,
  EvaluationTaxonomyInput,
  EvaluationTaxonomyInputUnion,
  EvaluationTaxonomyInputType,
  AgentTaxonomyInput,
  Target,
  TargetUnion,
  AzureAIModelTarget,
  ModelSamplingParams,
  AzureAIAgentTarget,
  ToolDescription,
  RiskCategory,
  TaxonomyCategory,
  TaxonomySubCategory,
  EvaluatorVersion,
  EvaluatorType,
  EvaluatorCategory,
  EvaluatorDefinition,
  EvaluatorDefinitionUnion,
  EvaluatorDefinitionType,
  EvaluatorMetric,
  EvaluatorMetricType,
  EvaluatorMetricDirection,
  CodeBasedEvaluatorDefinition,
  PromptBasedEvaluatorDefinition,
  Insight,
  InsightsMetadata,
  OperationState,
  InsightRequest,
  InsightRequestUnion,
  InsightType,
  EvaluationRunClusterInsightRequest,
  InsightModelConfiguration,
  AgentClusterInsightRequest,
  EvaluationComparisonInsightRequest,
  InsightResult,
  InsightResultUnion,
  EvaluationComparisonInsightResult,
  EvalRunResultComparison,
  EvalRunResultSummary,
  EvalRunResultCompareItem,
  TreatmentEffectType,
  EvaluationRunClusterInsightResult,
  ClusterInsightResult,
  InsightSummary,
  ClusterTokenUsage,
  InsightCluster,
  InsightSample,
  InsightSampleUnion,
  SampleType,
  EvaluationResultSample,
  EvalResult,
  ChartCoordinate,
  AgentClusterInsightResult,
  MemoryStoreDefinition,
  MemoryStoreDefinitionUnion,
  MemoryStoreKind,
  MemoryStoreDefaultDefinition,
  MemoryStoreDefaultOptions,
  MemoryStore,
  DeleteMemoryStoreResponse,
  MemoryStoreSearchResponse,
  MemorySearchItem,
  MemoryItem,
  MemoryItemUnion,
  MemoryItemKind,
  UserProfileMemoryItem,
  ChatSummaryMemoryItem,
  MemoryStoreOperationUsage,
  ResponseUsageInputTokensDetails,
  ResponseUsageOutputTokensDetails,
  MemoryStoreUpdateResponse,
  MemoryStoreUpdateStatus,
  MemoryStoreUpdateCompletedResult,
  MemoryOperation,
  MemoryOperationKind,
  MemoryStoreDeleteScopeResponse,
  RedTeam,
  AttackStrategy,
  TargetConfig,
  TargetConfigUnion,
  AzureOpenAIModelConfiguration,
  Schedule,
  ScheduleProvisioningStatus,
  Trigger,
  TriggerUnion,
  TriggerType,
  CronTrigger,
  RecurrenceTrigger,
  RecurrenceSchedule,
  RecurrenceScheduleUnion,
  RecurrenceType,
  HourlyRecurrenceSchedule,
  DailyRecurrenceSchedule,
  WeeklyRecurrenceSchedule,
  DayOfWeek,
  MonthlyRecurrenceSchedule,
  OneTimeTrigger,
  ScheduleTask,
  ScheduleTaskUnion,
  ScheduleTaskType,
  EvaluationScheduleTask,
  InsightScheduleTask,
  ScheduleRun,
  ToolboxPolicies,
  ToolboxVersionObject,
  ToolboxObject,
  SkillObject,
  DeleteSkillResponse,
  UpdateToolboxRequest,
  AgentType,
  AgentDefinitionOptInKeys,
  PageOrder,
  FoundryFeaturesOptInKeys,
  PendingUploadType,
  MemoryStoreType,
  KnownApiVersions,
  BetaSkillsDownloadResponse,
  BetaAgentsDownloadSessionFileResponse,
} from "./models.js";
